// Google maps
var geocoder;
var map;
var currentUserLat;
var currentUserLng;

function initialize() {
  geocoder = new google.maps.Geocoder();
  var myOptions = {
     zoom: 8,
     mapTypeId: google.maps.MapTypeId.ROADMAP,
     scaleControl: true,
  }
  map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);

  // Note: Used for mobile version only on Course details page.
  if($(window).width() <= 768) {
    map = new google.maps.Map(document.getElementById("map_canvas1"), myOptions);
  }

  var scaleInterval = setInterval(function() {
    var scale = $(".gm-style-cc:not(.gmnoprint):contains(' km')");
    if (scale.length) {
      scale.click();
      clearInterval(scaleInterval);
    }
  }, 100);
}

function codeAddress(address, icon_url) {
    if (geocoder) {
        geocoder.geocode( { 'address': address}, function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
              if (status != google.maps.GeocoderStatus.ZERO_RESULTS) {
                map.setCenter(results[0].geometry.location);
                var image = {
                  url: icon_url,
                  scaledSize: new google.maps.Size(35, 45)
                };
                var marker = new google.maps.Marker({
                  map: map,
                  position: results[0].geometry.location,
                  icon: image
                });
              }
            }
        });
    }
}


//Numeric value validation
function isNumber(n)
{
  if(n.value.indexOf(".")==-1)
     n.value = n.value.replace(/[^\d-]+/g, '');
}

// Google Map for courses index page to show top 10 courses on the map
function initMap() {
  var mapOptions = {
    zoom: 8,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    gestureHandling: 'greedy',
    scaleControl: true,
  }
  map = new google.maps.Map(document.getElementById("map_canvas"), mapOptions);

  var scaleInterval = setInterval(function() {
    var scale = $(".gm-style-cc:not(.gmnoprint):contains(' km')");
    if (scale.length) {
      scale.click();
      clearInterval(scaleInterval);
    }
  }, 100);
}

function initDirectionMap(from, to, callSearchPolyline) {
  var directionsService = new google.maps.DirectionsService();
  var directionsDisplay = new google.maps.DirectionsRenderer();
  var mapOptions = {
    zoom: 8,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    gestureHandling: 'greedy',
    scaleControl: true,
  }

  var scaleInterval = setInterval(function() {
    var scale = $(".gm-style-cc:not(.gmnoprint):contains(' km')");
    if (scale.length) {
      scale.click();
      clearInterval(scaleInterval);
    }
  }, 100);

  map = new google.maps.Map(document.getElementById("map_canvas"), mapOptions);

  directionsDisplay.setMap(map);
  directionsDisplay.setPanel(document.getElementById('panel'));
  directionsDisplay.setOptions( { suppressMarkers: true } );

  var request = {
    origin: from.replace('[','').replace(']',''), 
    destination: to.replace('[','').replace(']',''),
    travelMode: google.maps.DirectionsTravelMode.DRIVING
  };
  
  directionsService.route(request, function(response, status) {
    if (status == google.maps.DirectionsStatus.OK) {
      directionsDisplay.setDirections(response);
      callSearchPolyline(JSON.stringify(response.routes[0].legs));
    }
  }).then(function(result){
    fromLatLang = JSON.parse(from)
    var myFromLatlng = new google.maps.LatLng(fromLatLang[0], fromLatLang[1]);
    var marker_start = new google.maps.Marker({
      position: myFromLatlng,
      map: map,
      title: 'Start',
      icon: {
        url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
        scaledSize: new google.maps.Size(50, 50)
      }
    });
    toLatLang = JSON.parse(to)
    var myToLatlng = new google.maps.LatLng(toLatLang[0], toLatLang[1]);
    var marker_end = new google.maps.Marker({
      position: myToLatlng,
      map: map,
      title: 'End',
      icon: {
        url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
        scaledSize: new google.maps.Size(50, 50)
      }
    });
  });
}

function tolerance_from_distance(range){
  return ((range * 0.001) / 111)
}

function haversine_distance(mk1, mk2) {
  var R = 3958.8; 
  var rlat1 = mk1.lat() * (Math.PI/180);
  var rlat2 = mk2.lat() * (Math.PI/180);
  var difflat = rlat2-rlat1;
  var difflon = (mk2.lng()-mk1.lng()) * (Math.PI/180);
  var d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat/2)*Math.sin(difflat/2)+Math.cos(rlat1)*Math.cos(rlat2)*Math.sin(difflon/2)*Math.sin(difflon/2)));
  return d;
}

function searchPolyline(from, to, all_addresses, search_nearby_path, range, result) {
  var custom_range = (range * 10.7)/4.11
  var local_range = ((custom_range * 194.5) / 255.35)
  var tolerance = tolerance_from_distance(local_range * 1000)
  var direction_legs = JSON.parse(result);
  var direction_hands = [];
  var cascadiaFault = new google.maps.Polyline({
    path: [
      new google.maps.LatLng(from[0], from[1]),
    ]
  });
  window.from_map_marker = new google.maps.LatLng(from[0], from[1]);
  window.to_map_marker = new google.maps.LatLng(to[0], to[1])
  for (i=0;i<direction_legs.length;i++) {
    var steps = direction_legs[i].steps;
    for (j=0;j<steps.length;j++) {
      var nextSegment = steps[j].path;
      for (k=0;k<nextSegment.length;k++) {
        var direction_hand = new google.maps.LatLng(nextSegment[k].lat, nextSegment[k].lng)
        cascadiaFault.getPath().push(direction_hand);
        direction_hands.push(direction_hand)
      }
    }
  }
  cascadiaFault.getPath().push(new google.maps.LatLng(to[0], to[1]));
  var near_by_locations = []
  for(var i = 0; i < all_addresses.length; i++){
    myPosition = new google.maps.LatLng(all_addresses[i][0], all_addresses[i][1]);
    for(var v = 0; v < direction_hands.length; v++){
      if(haversine_distance(direction_hands[v], myPosition) <= range){
        near_by_locations.push([all_addresses[i][0], all_addresses[i][1], all_addresses[i][2], haversine_distance(direction_hands[v], myPosition)]);
        break;
      }
    }
  }
  sessionStorage.removeItem('direction_legs')
  $.ajax({
    type: "POST",
    url: search_nearby_path,
    data: { near_by_locations: near_by_locations, from: from, to: to},
    dataType: 'script'
  });
}

function c_markers(a, b){
  return a.haversine_distance - b.haversine_distance
}

function showMapWithAddress(mapData, lat, lng, map_course_sorting_applied) {
  currentUserLat = lat
  currentUserLng = lng
  markers = mapData
  //Create and open InfoWindow.
  var infoWindow = new google.maps.InfoWindow();
  for (var i = 0; i < markers.length; i++) {
    var data = markers[i];
    var myLatlng = new google.maps.LatLng(data.lat, data.lng);
    var image = {
      url: data.marker_icon,
      scaledSize: new google.maps.Size(35, 45)
    };

    var marker = new google.maps.Marker({
      position: myLatlng,
      map: map,
      title: data.name,
      icon: image,
    });

    // Attach click event to the marker.
    (function (marker, data) {
      google.maps.event.addListener(marker, "click", function (e) {
        //Wrap the content inside an HTML DIV in order to set height and width of InfoWindow.
        infoWindow.setContent(
          "<div class='mapinfo-box-images'><div class='mapinfo-box-hero-img'><img src="+data.hero_image+"></div>"+
          "<div class='sm-images'>"+
            "<img src="+data.supporting_image_1+">"+
            "<img src="+data.supporting_image_2+">"+
          "</div></div>"+ requestARoundLink(data) +
          "<div>"+data.city +', '+data.state+"</div>"
        );
        infoWindow.open(map, marker);
      });
    })(marker, data);
  }

  if(map_course_sorting_applied){
    // var starting_map_marker_latitude
    for(var v = 0; v < markers.length; v++){
      forPosition = new google.maps.LatLng(markers[v].lat, markers[v].lng);
      h_d = haversine_distance(forPosition, window.from_map_marker)
      markers[v]['haversine_distance'] = h_d
      $('.parent_div_course_' + markers[v].course_id).attr("data-h-d", h_d);
    }
    markers.sort(c_markers)
    var $wrapper = $('.courses_list_parent_div');
    $wrapper.find('.course_parent_div').sort(function(a, b) {
      return + a.dataset.hD - +b.dataset.hD;
    }).appendTo($wrapper);
  } else {
    // Center the map for according to current user lat/lng'
    map.setCenter({lat: currentUserLat, lng: currentUserLng});
  }
}

function requestARoundLink(data) {
  if (data.is_course_member) {
    return "<div class='mapinfo-box-course-name'>"+data.name+"</div>"
  } else {
    return "<a href=/courses/"+data.course_id+"/matches/new target='blank'>"+data.name+"</a>"
  }
}

// Attach fullscreen event to document
document.addEventListener("fullscreenchange", function () {
    (document.fullscreen)? addFullScreenClass() : removeFullScreenClass()
}, false);

document.addEventListener("mozfullscreenchange", function () {
    (document.mozFullScreen)? addFullScreenClass() : removeFullScreenClass()
}, false);

document.addEventListener("webkitfullscreenchange", function () {
    (document.webkitIsFullScreen)? addFullScreenClass() : removeFullScreenClass()
}, false);

document.addEventListener("msfullscreenchange", function () {
    (document.msFullscreenElement)? addFullScreenClass() : removeFullScreenClass()
}, false);


function addFullScreenClass() {
  $('.gm-style').addClass('map-fullscreen');
}

function removeFullScreenClass() {
  $('.gm-style').removeClass('map-fullscreen');
}
